import { render, staticRenderFns } from "./theme-dark-svg.vue?vue&type=template&id=5b54afc6&scoped=true"
import script from "./theme-dark-svg.vue?vue&type=script&lang=js"
export * from "./theme-dark-svg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b54afc6",
  null
  
)

export default component.exports